// IT -> EN dictionary for runtime UI translation.
// Keys are the EXACT Italian strings that appear as full text nodes or in
// placeholder/title/aria-label attributes. Only exact (trimmed) matches are
// translated, so dynamic data (player names, numbers) is never touched.
export const IT_EN = {
  // --- Viscidi Matrix ---
  "Matrice di Viscidi": "Viscidi Matrix",
  "Configura eventi e pesi": "Configure events & weights",
  "Pericolosità offensiva (IPO) vs difensiva (IRD) incrociata col possesso palla.": "Offensive danger (IPO) vs defensive risk (IRD) crossed with ball possession.",
  "Diagramma a 4 quadranti": "4-quadrant diagram",
  "Dominio": "Dominance",
  "Efficace in ripartenza": "Effective on the break",
  "Possesso sterile": "Sterile possession",
  "A rischio": "At risk",
  "Possesso palla %": "Ball possession %",
  "Possesso palla": "Ball possession",
  "Salva matrice": "Save matrix",
  "Salva pesi": "Save weights",
  "Rimuovi dati": "Remove data",
  "Importa Excel / SICS": "Import Excel / SICS",
  "Importo…": "Importing…",
  "Template Excel": "Excel template",
  "Nostra (IPO)": "Ours (IPO)",
  "Subiti (IRD)": "Conceded (IRD)",
  "Evento": "Event",
  "Peso": "Weight",
  "Quadrante": "Quadrant",
  "Partita": "Match",
  "Possesso": "Possession",
  "I pesi (scala 0–10) valgono sia per l'Offensive Index (IPO) sia per il Defensive Index (IRD).": "Weights (0–10 scale) apply to both the Offensive Index (IPO) and the Defensive Index (IRD).",
  "File importato · controlla e salva": "File imported · review and save",
  "Matrice salvata": "Matrix saved",
  "Pesi aggiornati": "Weights updated",
  "Dati rimossi": "Data removed",
  "Diagramma a dispersione": "Scatter diagram",
  "Nessuna partita con dati. Aggiungi i dati di una partita qui sotto o dal Calendario.": "No match has data yet. Add a match's data below or from the Calendar.",
  "Nessun dato inserito.": "No data entered.",
  "Andamento giornata per giornata": "Matchday-by-matchday trend",
  "Nessun dato: inserisci le partite per vedere l'andamento.": "No data yet: add matches to see the trend.",
  "Calendario Stagione": "Season Calendar",
  "Configura eventi e pesi": "Configure events & weights",
  "Esporta PDF": "Export PDF",
  "Esporto…": "Exporting…",
  // --- scouting player economic fields (full-node overrides so single words aren't partially translated) ---
  "Salario lordo (€)": "Gross salary (€)",
  "Costo transfer fee (€)": "Transfer fee cost (€)",
  "Salario lordo": "Gross salary",
  "Costo transfer fee": "Transfer fee cost",
  // --- standings board / dashboard labels ---
  "Loghi": "Logos",
  "Marcatori": "Markers",
  "Aggiorna": "Refresh",
  "Aggiorno…": "Refreshing…",
  "Punti fatti": "Points scored",
  "GF : GS": "GF : GA",
  // --- Sofascore standings embed ---
  "Classifica da Sofascore": "Standings from Sofascore",
  "Aggiungi classifica da Sofascore": "Add standings from Sofascore",
  "Cambia": "Change",
  "Importa classifica da Sofascore": "Import standings from Sofascore",
  "Incolla qui sotto il codice embed della classifica del tuo campionato.": "Paste your league's standings embed code below.",
  "Come trovare il codice:": "How to find the code:",
  "Su Sofascore apri la classifica del tuo campionato e premi il pulsante": "On Sofascore, open your league's standings and press the button",
  ": copia il codice e incollalo qui. Ogni campionato ha il suo codice specifico.": ": copy the code and paste it here. Each league has its own code.",
  "Classifiche fornite da Sofascore": "Standings provided by Sofascore",
  "Classifica live via Sofascore": "Live standings via Sofascore",
  "Classifica Sofascore salvata": "Sofascore standings saved",
  "Classifica Sofascore rimossa": "Sofascore standings removed",
  "Codice non valido. Incolla il codice embed di Sofascore (pulsante </>).": "Invalid code. Paste the Sofascore embed code (</> button).",
  // --- out periods / medical reasons ---
  "Storico indisponibilità · periodi out": "Unavailability history · out periods",
  "Totale giorni out stagionali:": "Total seasonal days out:",
  "Nessun periodo di indisponibilità registrato.": "No unavailability period recorded.",
  "in corso": "ongoing",
  "Inizio indisponibilità": "Unavailability start",
  "Inizio": "Start",
  "Fine (vuoto = in corso)": "End (blank = ongoing)",
  "Motivo dell'indisponibilità": "Reason for unavailability",
  "Motivo": "Reason",
  "Motivo…": "Reason…",
  "Motivo non specificato": "Reason not specified",
  "Specifica motivo…": "Specify reason…",
  "Nota": "Note",
  "Dettagli…": "Details…",
  "Dettagli (diagnosi, grado, trattamento)…": "Details (diagnosis, grade, treatment)…",
  "Aggiungi periodo": "Add period",
  "Periodo aggiunto": "Period added",
  "Periodo aggiornato": "Period updated",
  "Periodo rimosso": "Period removed",
  "Infortunio": "Injury",
  "Infortunio muscolare": "Muscle injury",
  "Infortunio articolare": "Joint injury",
  "Recidiva": "Recurrence",
  "Malattia": "Illness",
  "Carico di lavoro": "Workload",
  "Altro": "Other",
  // --- common verbs / buttons ---
  "Annulla": "Cancel",
  "Salva": "Save",
  "Salva forma": "Save shape",
  "Salva modifiche": "Save changes",
  "Aggiungi": "Add",
  "Rimuovi": "Remove",
  "Modifica": "Edit",
  "Modifica forma": "Edit shape",
  "Elimina": "Delete",
  "Elimina metrica": "Delete metric",
  "Elimina preset": "Delete preset",
  "Elimina selezionati": "Delete selected",
  "Rinomina preset": "Rename preset",
  "Indietro": "Back",
  "Chiudi": "Close",
  "Conferma": "Confirm",
  "Conferma nome": "Confirm name",
  "Conferma password": "Confirm password",
  "Conferma la password": "Confirm password",
  "Carica": "Upload",
  "Scarica": "Download",
  "Esporta": "Export",
  "Esporta PDF": "Export PDF",
  "Importa": "Import",
  "Importa Excel": "Import Excel",
  "Seleziona tutti": "Select all",
  "Seleziona ruolo": "Select role",
  "Ripristina ruolo": "Reset role",
  "Rimuovi dalla mappa": "Remove from map",
  "Aggiungi alla mappa": "Add to map",

  // --- fields / labels ---
  "Nome": "Name",
  "Nome e cognome": "Full name",
  "Cognome": "Surname",
  "Note": "Notes",
  "Data": "Date",
  "Ruolo": "Role",
  "Categoria": "Category",
  "Squadra": "Team",
  "Nostra squadra": "Our team",
  "Avversario": "Opponent",
  "Avversario:": "Opponent:",
  "Capitano": "Captain",
  "Mercato": "Market",
  "Peso": "Weight",
  "Posizione": "Position",
  "Formato": "Format",
  "Preset": "Preset",
  "Media": "Average",
  "Nella media": "Average",
  "Giornata": "Matchday",
  "Ingaggio": "Wage",
  "Tipo contratto": "Contract type",
  "Tipo infortunio": "Injury type",
  "Data infortunio": "Injury date",
  "Data movimento": "Transfer date",
  "Data rientro": "Return date",
  "Rientro stimato": "Estimated return",
  "Settimane di stop": "Weeks out",
  "Lordo €": "Gross €",
  "Netto €": "Net €",
  "lordo": "gross",
  "Costo azienda": "Company cost",
  "costo azienda": "company cost",
  "Costo azienda totale": "Total company cost",
  "Costo totale lordo": "Total gross cost",
  "Scadenza (anno)": "Expiry (year)",

  // --- statuses ---
  "Tutte": "All",
  "Tutti": "All",
  "Nessuna": "None",
  "Completata": "Completed",
  "Completato": "Completed",
  "In prestito": "On loan",
  "In rosa": "In squad",
  "In corso / vista": "In progress / seen",
  "Da vedere": "To watch",
  "Da rivedere": "To review",
  "Infortunate": "Injured",
  "Prima Squadra": "First Team",

  // --- phrases ---
  "0 = disattivato": "0 = disabled",
  "% sul lordo": "% on gross",
  "Aggiungi / sostituisci metrica…": "Add / replace metric…",
  "Aggiungi campionato (es. Serie A, WSL)…": "Add league (e.g. Serie A, WSL)…",
  "Aggiungi giornata": "Add matchday",
  "Aggiungi gol": "Add goal",
  "Aggiungi lega": "Add league",
  "Aggiungi metrica": "Add metric",
  "Aggiungi un match → carica le sue giocatrici": "Add a match → load its players",
  "Aggiungi video": "Add video",
  "Alert mercato · saldo in deficit": "Market alert · deficit balance",
  "Applica il coefficiente al FT X": "Apply the coefficient to FT X",
  "Apri fonte": "Open source",
  "Area riservata": "Restricted area",
  "Assist vincente": "Assist",
  "Autogol avversario": "Opponent own goal",
  "Autogol avversario (conta solo per il risultato)": "Opponent own goal (counts only for the score)",
  "Autore (chi lo ha fatto)": "Author (who did it)",
  "Autore del dossier": "Dossier author",
  "Azzerare i colori della mappa?": "Reset the map colors?",
  "Blu (da vedere)": "Blue (to watch)",
  "blu (da vedere)": "blue (to watch)",
  "Budget lordo Rosa €": "Squad gross budget €",
  "Budget lordo Staff €": "Staff gross budget €",
  "Budget monte ingaggi lordo · Lista A + B + FL + U19": "Gross wage bill budget · List A + B + FL + U19",
  "Budget monte ingaggi lordo · Staff Serie A": "Gross wage bill budget · Serie A Staff",
  "Calciatrice internazionale (convocata in nazionale)": "International player (called up for national team)",
  "Calciatrici in prestito": "Players on loan",
  "Carica uno o più file": "Upload one or more files",
  "Cerca calciatrice o skill…": "Search player or skill…",
  "Cerca club / paese / lega…": "Search club / country / league…",
  "Classifica assist": "Assists ranking",
  "Classifica assist vincenti": "Key assists ranking",
  "Clicca per aggiungere · resta aperto": "Click to add · stays open",
  "Clicca sul campo per posizionare il pallone.": "Click on the pitch to place the ball.",
  "Clicca una nazione per cambiare stato:": "Click a country to change status:",
  "Click per rettificare": "Click to adjust",
  "Club di destinazione": "Destination club",
  "Codici PIN · per area": "PIN codes · per area",
  "Collega a partita (calendario · pulsante “Scout”)": "Link to match (calendar · \u201cScout\u201d button)",
  "Collegata a Scout": "Linked to Scout",
  "Colonne extra (dai dati per giornata):": "Extra columns (from matchday data):",
  "Con più metriche ogni linea è un": "With more metrics each line is a",
  "Confronta uno o più match interi:": "Compare one or more full matches:",
  "Costo annuo rosa (azienda + Fee agenti)": "Annual squad cost (company + Agent fees)",
  "Costo azienda = Lordo × (1 + Inps% + Fondo% + Inail%).": "Company cost = Gross × (1 + Inps% + Fund% + Inail%).",
  "Costo azienda stimato:": "Estimated company cost:",
  "Cronologia gol": "Goal history",
  "Dettagli video libreria.": "Library video details.",
  "Direttore Sportivo →": "Sport Director →",
  "Dossier con copertina": "Dossier with cover",
  "File (una riga per squadra)": "File (one row per team)",
  "File SICS (stat squadra)": "SICS file (team stats)",
  "Filtra per club…": "Filter by club…",
  "Finestra mercato": "Transfer window",
  "Giallo (in corso / vista)": "Yellow (in progress / seen)",
  "Gol · marcatrice & assist vincente": "Goal · scorer & key assist",
  "Ha reimpostato la password: riapprova per riattivare l'accesso": "Password reset: re-approve to re-enable access",
  "IN CAMPO": "ON PITCH",
  "Il coefficiente segue il": "The coefficient follows the",
  "Import Excel mercato": "Market Excel import",
  "Importa avversario da Serie A": "Import opponent from Serie A",
  "Importo pagato": "Amount paid",
  "Infortunate · lungo periodo": "Injured · long term",
  "Infortunio · lungo periodo": "Injury · long term",
  "Ingaggi in entrata (IN)": "Incoming signings (IN)",
  "Inps % (sul lordo)": "Inps % (on gross)",
  "La finestra": "The window",
  "Livello vs media ruolo:": "Level vs role average:",
  "Media Serie A": "Serie A average",
  "Media punti · Serie A": "Points average · Serie A",
  "Min. minuti giocati": "Min. minutes played",
  "Monte ingaggi impegnato · proiezione per stagione": "Committed wage bill · projection per season",
  "Mostro max 80 risultati: affina la ricerca per un club specifico.": "Showing max 80 results: refine the search for a specific club.",
  "Nessun agente salvato. Aggiungine uno o importa la rosa.": "No agent saved. Add one or import the squad.",
  "Nessun dato — carica gli Stats dal Season calendar.": "No data — load Stats from the Season calendar.",
  "Nessun movimento corrisponde al filtro.": "No transfer matches the filter.",
  "Nessun preset salvato": "No saved preset",
  "Nessun preset — configurazione attiva": "No preset — active configuration",
  "Nessun video in libreria. Aggiungi il primo con \"Aggiungi video\".": "No video in library. Add the first with \"Add video\".",
  "Nessuna metrica in top 3.": "No metric in top 3.",
  "Nessuna metrica nelle ultime 3.": "No metric in bottom 3.",
  "Nessuna partita collegata": "No match linked",
  "Nessuna variazione dalla giornata precedente": "No change from previous matchday",
  "Nessuno staff.": "No staff.",
  "Nome (es. Turchia)": "Name (e.g. Turkey)",
  "Nome A-Z": "Name A-Z",
  "Nome analista / coach": "Analyst / coach name",
  "Nome avversario": "Opponent name",
  "Nome club · Nome lega · Nazione": "Club name · League name · Country",
  "Non form. ITA": "Non-homegrown ITA",
  "Nuova password": "New password",
  "Nuovo agente…": "New agent…",
  "Nuovo nome preset": "New preset name",
  "Oppure senza file:": "Or without file:",
  "Opzione — nota": "Option — note",
  "Opzione — nuova scadenza (anno)": "Option — new expiry (year)",
  "Opzione — scadenza": "Option — expiry",
  "Opzioni di esportazione PDF": "PDF export options",
  "Ordina per:": "Sort by:",
  "Password dimenticata?": "Forgot password?",
  "Pesi FT X per ruolo": "FT X weights per role",
  "Pre-match · confronto avversario": "Pre-match · opponent comparison",
  "Prima Squadra (A+B+FL) · lordo": "First Team (A+B+FL) · gross",
  "Prima Squadra (A+B+FL) + Infortunate + U19 + Staff prima squadra": "First Team (A+B+FL) + Injured + U19 + First-team staff",
  "Preset salvati:": "Saved presets:",
  "Pulisci il campo e ricomincia da capo": "Clear the pitch and start over",
  "Ratio Netto/Lordo default": "Default Net/Gross ratio",
  "Rientri dal prestito": "Returns from loan",
  "Rientri in arrivo · prestiti & infortuni": "Upcoming returns · loans & injuries",
  "Rimuovere il video?": "Remove the video?",
  "Ruolo dell'autore": "Author role",
  "Scegli dall'elenco o scrivi una skill e premi Invio": "Choose from the list or type a skill and press Enter",
  "Scegli il formato e indica l'autore del dossier.": "Choose the format and indicate the dossier author.",
  "Serie A · dove siamo forti e deboli": "Serie A · where we are strong and weak",
  "Settore Giovanile · lordo": "Youth Sector · gross",
  "Situazione di gioco": "Game situation",
  "Soglia alert deficit mercato €": "Market deficit alert threshold €",
  "Sposta in U19 professioniste": "Move to U19 professionals",
  "Stai per eliminare": "You are about to delete",
  "Stato analisi nazione": "Country analysis status",
  "Sul campo:": "On the pitch:",
  "Titolo relazione (per la libreria)": "Report title (for the library)",
  "Torna al movimento precedente (Shift + Z)": "Undo last move (Shift + Z)",
  "Totale fuori organico": "Total out of squad",
  "Transfer fee incassato (text)": "Transfer fee received (text)",
  "Transfer fee incassato €": "Transfer fee received €",
  "Tutte le metriche sono già presenti": "All metrics are already present",
  "Tutte le nazioni torneranno": "All countries will return",
  "Tutti i club presenti nei dati sono mappati. 🎉": "All clubs in the data are mapped. 🎉",
  "Upload giornata": "Upload matchday",
  "Vedi i piani e prezzi": "See plans and pricing",
  "Verde (completata)": "Green (completed)",
  "Vuoi provare Technical Hub per il tuo club?": "Want to try Technical Hub for your club?",
  "aggiungine altri per sommare/mediare sui match": "add more to sum/average over matches",
  "assist di": "assist by",
  "chiude con Balance": "closes with Balance",
  "dalla libreria. Operazione non annullabile.": "from the library. This cannot be undone.",
  "es. Costruzione dal basso 3v2": "e.g. Build-up from the back 3v2",
  "formato .xlsx · puoi caricarne più di uno": ".xlsx format · you can upload more than one",
  "importante per ruolo": "important for role",
  "indice vs media Serie A": "index vs Serie A average",
  "usa la media stagionale già caricata": "use the season average already loaded",
  "— Non indicato": "— Not specified",
  "— nessun assist": "— no assist",
  "🛡️ Non possesso": "🛡️ Out of possession",
  "(100 = media della lega). Sopra 100 = meglio della media.": "(100 = league average). Above 100 = better than average.",
  "(opzionale · abilita i suggerimenti multi-ruolo nel Squad)": "(optional · enables multi-role suggestions in Squad)",
  ". Le leghe elencate non verranno toccate.": ". The listed leagues will not be touched.",
  "0 = avvisa su qualsiasi saldo negativo": "0 = warn on any negative balance",
  "Verrà rimosso": "Will be removed",
  // --- director / squad composites & titles ---
  "Fuori organico": "Out of squad",
  "Fuori (FL+Inf.)": "Out (FL+Inj.)",
  "Sync numeri": "Sync numbers",
  "Britanniche": "British",
  "Settore giovanile": "Youth sector",
  "Lordo delle calciatrici sotto contratto in ogni stagione (scende con le scadenze). In verde il lordo di chi rientra dal prestito.": "Gross of players under contract each season (decreases with expiries). In green, the gross of those returning from loan.",
  "In entrata (IN)": "Incoming (IN)",
  "In uscita (OUT)": "Outgoing (OUT)",
  "Saldo mercato": "Market balance",
  "Scadenze contratto": "Contract expiries",
  // --- login ---
  "ACCEDI": "SIGN IN", "Accedi": "Sign in",
  // --- dashboard leader metric titles (from backend, title-case; CSS uppercases) ---
  "Duelli vinti": "Duels won", "Duelli offensivi": "Offensive duels", "Duelli difensivi": "Defensive duels",
  "Passaggi riusciti": "Successful passes", "% passaggi riusciti": "% successful passes",
  "Min. minuti giocati": "Min. minutes played", "Min. passaggi (% passaggi)": "Min. passes (% passes)",
  "Classifica completa": "Full ranking",
  // --- scouting watchlist labels ---
  "Altissimo": "Very high", "Alto": "High", "Basso": "Low", "Molto basso": "Very low",
  "Pesi FT X": "FT X weights", "Coeff. Lega": "League coeff.", "Provenienza": "Origin",
  "Solo EU": "EU only", "Solo EXTRA EU": "NON-EU only", "TUTTE": "ALL",
  "Gestisci il coefficiente lega: attiva/disattiva, modifica i valori, aggiungi o elimina leghe.": "Manage the league coefficient: enable/disable, edit values, add or delete leagues.",
  "Filtra per provenienza: Tutte → Solo EU (azzurro) → Solo EXTRA EU (arancio)": "Filter by origin: All → EU only (blue) → NON-EU only (orange)",
  // --- opponent / tactical board controls ---
  "Indietro": "Back",
  "Colore pedine": "Piece color", "Sociali (primario)": "Club (primary)", "Sociali (invertito)": "Club (inverted)",
  "Sul campo:": "On the pitch:", "Freccia": "Arrow", "Pallone": "Ball", "Sistema fluido / ibrido": "Fluid / hybrid system",
  "Trascina una pedina liberamente · rilasciala su un'altra per scambiarle": "Drag a piece freely · drop it on another to swap",
  // --- starting XI board ---
  "Nuova": "New", "Salva in libreria": "Save to library", "Aggiorna in libreria": "Update in library",
  "Punto di forza": "Strength point", "Punto debole": "Weak point",
  "Punti di forza": "Strengths", "Punti deboli": "Weaknesses",
  "Capitano": "Captain", "Vice-capitano": "Vice-captain",
  "Età media XI:": "Avg. age XI:", "Altezza media:": "Avg. height:", "età media": "avg. age", "altezza media": "avg. height", "Titolo (per la libreria)": "Title (for the library)", "Autore": "Author",
  "Modifica dalla libreria": "Editing from library", "Libreria · formazioni salvate": "Library · saved line-ups",
  "Nessuna formazione salvata. Dai un titolo e clicca \"Salva in libreria\".": "No line-up saved. Add a title and click \"Save to library\".",
  "Note / piano gara": "Notes / game plan", "Collega a partita (calendario)": "Link to match (calendar)",
  "Rigoristi (ordine di priorità — almeno 5)": "Penalty takers (priority order — at least 5)",
  "Evidenzia come area": "Highlight as area",
  // --- sport director / login / settings ---
  "Salari, scadenze contrattuali, composizione lista e controllo budget e mercato.": "Wages, contract deadlines, list composition and market budget control.",
  "Budget & Mercato": "Budget & Market",
  "Area riservata": "Members area",
  "Reimposta": "Reset",
  "Reimposta password": "Reset password",
  "Esporta rosa": "Export roster",
  "Bonus (variabile)": "Bonus (variable)",
  "Raggiunto": "Achieved",
  "Bonus": "Bonus",
  "Aggiornamento non riuscito": "Update failed",
  "Aggiungi esame": "Add exam",
  "Aggiungi esame / aggiornamento": "Add exam / update",
  "Aggiunta non riuscita": "Could not add",
  "Area del corpo": "Body area",
  "Classifica stagionale · minuti giocati": "Season ranking · minutes played",
  "Data effettiva rientro": "Actual return date",
  "Data stimata rientro": "Estimated return date",
  "Devi confermare l'adempimento GDPR (art. 9) per accedere.": "You must confirm GDPR compliance (art. 9) to access.",
  "Eliminazione non riuscita": "Delete failed",
  "Esame (es. RMN ginocchio)": "Exam (e.g. knee MRI)",
  "Esame aggiunto": "Exam added",
  "Esami diagnostici e aggiornamenti": "Diagnostic exams and updates",
  "Giorni out": "Days out",
  "Il titolo dell'esame è obbligatorio": "The exam title is required",
  "Il tuo nome": "Your name",
  "Impossibile verificare il PIN.": "Unable to verify the PIN.",
  "Indica almeno natura o tipo infortunio": "Specify at least the nature or type of injury",
  "Indica il nome dell'esame": "Specify the exam name",
  "Inserisci il PIN medico per accedere alle cartelle sanitarie delle calciatrici.": "Enter the medical PIN to access the players' health records.",
  "Inserisci la data di inizio": "Enter the start date",
  "Link referto medico": "Medical report link",
  "Link referto medico copiato": "Medical report link copied",
  "Minuti": "Minutes",
  "Minuti totali · infortuni · giorni out · periodo out": "Total minutes · injuries · days out · out period",
  "Nessun dato.": "No data.",
  "Nessun esame programmato.": "No exam scheduled.",
  "Nessuna calciatrice in rosa.": "No players in the squad.",
  "Nota allenamento parziale (es. niente sprint)": "Partial training note (e.g. no sprints)",
  "Nota referto tecnico (facoltativa, appare in tecnico/completo)": "Technical report note (optional, shown in technical/full)",
  "Nuovo link generato": "New link generated",
  "Operazione non riuscita": "Operation failed",
  "Recenti (stagione attuale)": "Recent (current season)",
  "Referto": "Report",
  "Rientro previsto": "Expected return",
  "Rimozione non riuscita": "Removal failed",
  "Rimuovere questo periodo di indisponibilità?": "Remove this unavailability period?",
  "Salva anamnesi": "Save anamnesis",
  "Salvataggio non riuscito": "Save failed",
  "Salvataggio non riuscito (serve accesso Medical)": "Save failed (Medical access required)",
  "Tipo (es. Distorsione)": "Type (e.g. Sprain)",
  "Titolo esame / aggiornamento": "Exam / update title",
  "Riservato · Medica": "Restricted · Medical",
  "Riservato · Cartella medica": "Restricted · Medical record",
  "Area Medica": "Medical Area",
  "Disponibilità": "Availability",
  "Disponibilità · prossima seduta": "Availability · next session",
  "Disponibile": "Available",
  "Parzialmente disponibile": "Partially available",
  "Indisponibile": "Unavailable",
  "Periodo out": "Out period",
  "Storico infortuni": "Injury history",
  "Anamnesi": "Anamnesis",
  "Anamnesi medica": "Medical anamnesis",
  "Dossier completo": "Full dossier",
  "Rosa al completo disponibile — nessuna calciatrice segnalata limitata o indisponibile.": "Full squad available — no player flagged as limited or unavailable.",
  "Nessun dato di minutaggio disponibile. Importa gli stats di partita per popolare la classifica.": "No minutes data available. Import match stats to populate the ranking.",
  "Scegli cosa consegnare: un dossier tecnico (GPS, statistiche gara e fisico), solo il referto medico, oppure il dossier completo che unisce entrambi — tutto con il brand Parma Calcio 1913.": "Choose what to share: a technical dossier (GPS, match stats and physical), the medical report only, or the full dossier combining both — all with the Parma Calcio 1913 brand.",
  "calciatrici · anamnesi, storico infortuni, esami diagnostici e mappa corporea interattiva per ogni calciatrice. Seleziona una calciatrice per aprire la sua cartella medica.": "players · anamnesis, injury history, diagnostic exams and an interactive body map for each player. Select a player to open her medical record.",
  "Modifica scheda": "Edit record",
  "Esporta dossier": "Export dossier",
  "Copia link medico": "Copy medical link",
  "Remoti (precedenti)": "Earlier (previous)",
  "Clicca sulla mappa o scrivi…": "Click the map or type…",
  "es. stiramento flessori": "e.g. hamstring strain",
  "Infortunio (tag breve)": "Injury (short tag)",
  "Autore (medico)": "Author (doctor)",
  "Diagnosi, grado, trattamento…": "Diagnosis, grade, treatment…",
  "Aggiungi infortunio": "Add injury",
  "Per la prossima seduta:": "For the next session:",
  "Allergie": "Allergies",
  "Intolleranze": "Intolerances",
  "Intolleranze alimentari": "Food intolerances",
  "Farmaci da evitare": "Medications to avoid",
  "Farmaci in uso": "Current medications",
  "Patologie / condizioni mediche": "Pathologies / medical conditions",
  "Nessuno": "None",
  "Scrivi e premi Invio…": "Type and press Enter…",
  "Atteggiamento, comportamento e contesto": "Attitude, behaviour and context",
  "Comportamento durante gli eventi gara, carattere, leadership, reazioni, contesto…": "Behaviour during match events, character, leadership, reactions, context…",
  "es. Controllo RM ginocchio": "e.g. knee MRI check",
  "Dettagli / aggiornamento cartella…": "Record details / update…",
  "Invio automatico ore": "Auto-send time",
  "7 giorni": "7 days",
  "14 giorni": "14 days",
  "30 giorni": "30 days",
  "60 giorni": "60 days",
  "Andamento Wellness & RPE (media squadra)": "Wellness & RPE trend (team average)",
  "Gli invii automatici partono al primo controllo (ogni 15 min) dopo l'orario impostato. Usa \"Invia ora\" per invii fuori orario.": "Automatic sends start at the first check (every 15 min) after the set time. Use \"Send now\" for off-schedule sends.",
  "Media benessere ≥": "Wellness average ≥",
  "L'alert benessere scatta se la media raggiunge la soglia": "The wellness alert triggers if the average reaches the threshold",
  "una singola risposta raggiunge la soglia critica. L'alert RPE scatta al raggiungimento della soglia.": "a single answer reaches the critical threshold. The RPE alert triggers when the threshold is reached.",
  "Domande & parametri di voto": "Questions & scoring parameters",
  "Benessere in allerta": "Wellness on alert",
  "Invio giornaliero": "Daily send",
  "Chiusura benessere": "Wellness closing",
  "Messaggio di ringraziamento dopo il voto": "Thank-you message after submission",
  "Apri questionario": "Open survey",
  "Media delle risposte odierne.": "Average of today's answers.",
  "Sforzo percepito dopo l'allenamento.": "Perceived effort after training.",
  "Nessuna risposta registrata nel periodo.": "No answers recorded in the period.",
  "Benessere & RPE": "Wellness & RPE",
  "Nessun alert oggi — Players nei valori ottimali.": "No alerts today — players in optimal values.",
  "Budget & Mercato": "Budget & Market",
  "La sezione Budget & Mercato è disponibile dal piano Club. Aggiorna il tuo abbonamento per sbloccarla.": "The Budget & Market section is available from the Club plan. Upgrade your subscription to unlock it.",
  "Bonus · parte variabile del budget": "Bonus · variable part of the budget",
  "Nessun bonus. I bonus non raggiunti restano solo nel budget variabile.": "No bonus. Unmet bonuses remain only in the variable budget.",
  "Variabile (non raggiunti):": "Variable (unmet):",
  "Tutte le calciatrici di tutte le liste · senza staff": "All players from all lists · without staff",
  "Prima Squadra + Infortunate + U19 + Staff + Bonus raggiunti": "First Team + Injured + U19 + Staff + Bonuses achieved",
  "Rosa": "Squad",
  "Nessun bonus impostato per questa calciatrice.": "No bonus set for this player.",
  "Nuovo status (era \"Infortunata\")": "New status (was \"Injured\")",
  "— Nessuna —": "— None —",
  "PDF mercato": "Market PDF",
  "Scarica template": "Download template",
  "Import mercato Excel": "Import market Excel",
  "Nessun movimento con data. Aggiungi la data ai movimenti per vederli in ordine cronologico.": "No transaction with a date. Add a date to transactions to see them in chronological order.",
  "Incentivo all'esodo €": "Severance incentive €",
  "(buonuscita all'uscita)": "(severance on exit)",
  "Soglie budget & alert": "Budget thresholds & alerts",
  "Liste rosa · nomi & capienze": "Squad lists · names & capacities",
  "Descrizione bonus": "Bonus description",
  "Scegli la lista di destinazione": "Choose the destination list",
  "Rosa · stipendi & contratti": "Squad · salaries & contracts",
  "Nessuna riga. Aggiungine una.": "No rows. Add one.",
  "per inserire i profili a mano. Ogni colonna è filtrabile e ordinabile.": "to enter profiles manually. Every column is filterable and sortable.",
  "Dettaglio partita per partita": "Match-by-match detail",
  "Invia questionario ora": "Send survey now",
  "Configura": "Configure",
  "Anteprima scheda": "Preview card",
  "Invii automatici:": "Automatic sends:",
  "Tutti i reparti": "All departments",
  "Questionario": "Survey",
  "Copia link": "Copy link",
  "· chiusura benessere": "· wellness closing",
  "· chiusura RPE": "· RPE closing",
  "Sostituisci": "Replace",
  "Consulta / Scarica": "View / Download",
  "Allega modulo (PDF o foto)": "Attach form (PDF or photo)",
  "Modulo consenso:": "Consent form:",
  "Area Admin sbloccata": "Admin area unlocked",
  "PIN errato": "Wrong PIN",
  "Impossibile verificare il PIN": "Unable to verify the PIN",
  "PIN Admin": "Admin PIN",
  "Sblocca": "Unlock",
  "Per modificare brand, logo, piano, PIN e liste devi sbloccare l'area Admin con il PIN.": "To edit branding, logo, plan, PINs and lists you must unlock the Admin area with its PIN.",
  "Configura stati": "Configure statuses",
  "Configura stati rosa": "Configure roster statuses",
  "Aggiungi stato": "Add status",
  "Ripristina predefiniti": "Reset to defaults",
  "Aggiungi un match → carica Players (carica prima gli Stats dei match dal Season calendar)": "Add a match → load its players (first upload the match Stats from the Season calendar)",
  "Aggiungi un match → carica Players · aggiungine altri per sommare/mediare sui match": "Add a match → load its players · add more to sum/average across matches",
  "Classifiche marcatori & assist": "Scorers & assists rankings",
  "Esporta PDF · Marcatori e assist": "Export PDF · Scorers and assists",
  "Invio manuale · Chiusura benessere": "Manual send · Wellness closing",
  "Chiusura RPE": "RPE closing",
  "Orari di chiusura sondaggi": "Survey closing times",
  "Dopo l'orario di chiusura le calciatrici non possono più inviare le risposte di quel giorno. L'invio dei questionari è solo manuale con \"Invia questionario ora\".": "After the closing time players can no longer submit that day's answers. Surveys are sent manually only via \"Send survey now\".",
  "· promemoria disattivato": "· reminder disabled",
  "Costo totale lordo players": "Total gross players cost",
  "Excel storico saldi": "Balance history Excel",

  // === Season calendar page ===
  "Analisi Partite": "Match Analysis",
  "Analisi · Stagione 2026/27": "Analysis · Season 2026/27",
  "Calendario stagione": "Season calendar",
  "Calendario stagione 2026/27": "Season calendar 2026/27",
  "e le partite di coppa più le sessioni di allenamento settimanali. Le clip sono allegate a queste sessioni.": "and cup matches plus the weekly training sessions. Clips are attached to these sessions.",
  "Calendario": "Calendar",
  "Report squadra": "Team report",
  "Carica calendario": "Load calendar",
  "Classifiche": "Standings",
  "Inizia la tua stagione": "Start your season",
  "Genera allenamenti": "Generate trainings",
  "Aggiungi sessione": "Add session",
  "Giocate": "Played",
  "Vinte": "Won",
  "Pareggiate": "Drawn",
  "Perse": "Lost",
  "Gol fatti": "Goals for",
  "Gol subiti": "Goals against",
  "Forma · serie": "Form · streak",
  "Vittoria": "Win",
  "Pareggio": "Draw",
  "Sconfitta": "Loss",
  "· dalla più vecchia → alla più recente": "· from oldest → to newest",
  "Punti / gara · ": "Points / game · ",
  "GF : GA · rapporto ": "GF : GA · ratio ",
  "La media punti e il rapporto reti considerano solo le gare di ": "Points average and goal ratio consider only the matches of ",
  "— le coppe sono escluse.": "— cups are excluded.",
  "Partite": "Matches",
  "Settimane allenamento": "Training weeks",
  "Eliminare la sessione?": "Delete the session?",
  "Verranno eliminati anche i dati collegati (GPS, statistiche, report). Operazione non reversibile.": "Linked data (GPS, stats, reports) will also be deleted. This cannot be undone.",
  "Rimuoverà in modo permanente la partita": "Will permanently remove the match",
  "e tutti i dati GPS/statistiche importati e collegati. Operazione non annullabile.": "and all imported and linked GPS/stats data. This cannot be undone.",
  "Rimuoverà in modo permanente": "Will permanently remove",
  ". Operazione non annullabile.": ". This cannot be undone.",
  "questa sessione": "this session",
  "Modifica sessione": "Edit session",
  "Dettagli partita o sessione di allenamento.": "Match or training session details.",
  "Tipo": "Type",
  "Allenamento": "Training",
  "Casa": "Home",
  "Trasferta": "Away",
  "Competizione": "Competition",
  "Giornata / turno": "Matchday / round",
  "Es. G5, Turno 1…": "E.g. M5, Round 1…",
  "Risultato": "Result",
  "Nessun gol inserito. Aggiungi i gol segnati dal Parma (e/o autogol avversari).": "No goal entered. Add the goals scored by Parma (and/or opponent own goals).",
  "Marcatrice": "Scorer",
  "Autogol": "Own goal",
  "Titolo": "Title",
  "Settimana 5 / Sessione tattica": "Week 5 / Tactical session",
  "Salvataggio…": "Saving…",
  "Importa": "Import",
  "Importazione…": "Importing…",
  "una riga per calciatrice, prima colonna = nome.": "one row per player, first column = name.",
  "Tutte le colonne GPS vengono importate.": "All GPS columns are imported.",
  "Colonne statistiche partita dal tuo Excel (una riga per calciatrice).": "Match stats columns from your Excel (one row per player).",
  "Scarica il template statistiche vuoto (.xlsx con i nomi della rosa)": "Download the empty stats template (.xlsx with roster names)",
  "Svuota": "Empty",
  "Importa Team": "Import Team",
  "una riga coi totali squadra (riga intestazione + una sola riga totali \"Parma\"). Usa il template fisso così le colonne combaciano sempre.": "one row with team totals (header row + a single \"Parma\" totals row). Use the fixed template so columns always match.",
  "Genera settimane di allenamento": "Generate training weeks",
  "Le settimane che hanno già un allenamento vengono saltate.": "Weeks that already have a training are skipped.",
  "Training Week 1 (lunedì)": "Training Week 1 (Monday)",
  "Fine (auto)": "End (auto)",
  "Tipo sessione (opzionale)": "Session type (optional)",
  "Es. Allenamento settimanale, Carico, Scarico…": "E.g. Weekly training, Load, Unload…",
  "Genero…": "Generating…",
  "Genera": "Generate",
  "Carica calendario squadra": "Load team calendar",
  "Una competizione": "One competition",
  "Nome + logo, un calendario": "Name + logo, one calendar",
  "Più competizioni": "Multiple competitions",
  "File unico con colonna \"Competizione\"": "Single file with \"Competition\" column",
  "Nome competizione": "Competition name",
  "Es. Serie A Women 2026/27": "E.g. Serie A Women 2026/27",
  "Logo competizione (opzionale)": "Competition logo (optional)",
  "Calendario da file (.xlsx · .json · .xml)": "Calendar from file (.xlsx · .json · .xml)",
  "Calendario unico (.xlsx · .json · .xml)": "Single calendar (.xlsx · .json · .xml)",
  "Scarica il template (.xlsx)": "Download the template (.xlsx)",
  "Carico…": "Loading…",
  "Classifiche competizione": "Competition standings",
  "Scegli una competizione (create con \"Carica calendario\") e modifica la classifica: manuale, da Excel/JSON/XML o da URL.": "Choose a competition (created with \"Load calendar\") and edit the standings: manually, from Excel/JSON/XML or from a URL.",
  "Nessuna competizione. Usa prima \"Carica calendario\" per crearne una.": "No competition. Use \"Load calendar\" first to create one.",
  "— Seleziona —": "— Select —",
  "Incolla URL classifica…": "Paste standings URL…",
  "Da URL": "From URL",
  "Nessuna riga — importa o aggiungi a mano.": "No rows — import or add manually.",
  "Riga": "Row",
  "Classifica salvata": "Standings saved",
  "Seleziona la competizione e inserisci un URL": "Select the competition and enter a URL",
  "Import non riuscito": "Import failed",
  "Carica un file con la colonna 'Competizione'": "Upload a file with the 'Competition' column",
  "Inserisci il nome della competizione": "Enter the competition name",
  "Carica un file del calendario": "Upload a calendar file",
  "Import calendario non riuscito": "Calendar import failed",
  "La data è obbligatoria": "The date is required",
  "Squadra di casa e trasferta obbligatorie": "Home and away teams are required",
  "Sessione aggiornata": "Session updated",
  "Sessione aggiunta": "Session added",
  "Sessione eliminata": "Session deleted",
  "Scegli prima un file .xlsx": "Choose an .xlsx file first",
  "Dati rimossi": "Data removed",
  "Rimozione non riuscita": "Removal failed",
  "Caricamento non riuscito": "Upload failed",
  "Download non riuscito": "Download failed",
  "Dati squadra rimossi": "Team data removed",
  "Imposta la data d'inizio stagione": "Set the season start date",
  "Generazione non riuscita": "Generation failed",

  // === Analysis compare / trend panels ===
  "Confronto squadra · GPS": "Compare team · GPS stats",
  "Confronto squadra · statistiche": "Compare team · match stats",
  "Dai un nome al preset": "Give the preset a name",
  "Seleziona almeno una metrica": "Pick at least one metric",
  "Preset eliminato": "Preset deleted",
  "Seleziona almeno 2 partite e 3 metriche": "Pick at least 2 matches and 3 metrics first",
  "Nessun dato squadra": "No team data yet",
  "Creazione Excel…": "Building Excel…",
  "Esportazione Excel non riuscita": "Excel export failed",
  "Nessun dato squadra. Carica i totali squadra dalle partite nel Calendario stagione.": "No team data yet. Upload team totals from the matches in the Season calendar.",
  "partite con dati caricati": "matches with team data",
  "Partite (": "Matches (",
  "Aggiungi partita": "Add match",
  "Azzera": "Clear",
  "Metriche radar (": "Radar metrics (",
  "Carica preset…": "Load preset…",
  "Nessun preset": "No presets yet",
  "Nome preset (es. Fase di possesso)": "Preset name (e.g. Fase di possesso)",
  "Seleziona almeno 2 partite e 3 metriche per disegnare il radar (la media di tutte le partite è sempre mostrata come riferimento).": "Pick at least 2 matches and 3 metrics to draw the radar (the average of all matches is always shown for reference).",
  "Radar · ogni asse normalizzato al valore massimo = 100% · ": "Radar · each axis normalised to the top value = 100% · ",
  "Media (tutte le partite)": "Average (all matches)",
  "in evidenza": "highlighted",
  "Metrica": "Metric",
  "più basso è meglio": "lower is better",
  "Tutte le metriche squadra": "All team metrics",
  "Tutte le metriche squadra ·": "All team metrics ·",
  "statistiche partita": "match stats",
  "verde = miglior partita": "green = best match",
  "rosso = peggior partita": "red = worst match",
  "per ogni metrica (invertito per più-basso-è-meglio ▼).": "for each metric (inverted for lower-is-better ▼).",
  "Inserisci il numero di giornata": "Enter the matchday number",
  "Scegli un file .xlsx": "Choose an .xlsx file",
  "Dati selezionati insufficienti": "Not enough data selected",
  "Nessun dato Serie A. Clicca \"Carica giornata\" e carica un file per ogni giornata (colonna Squadra + una riga per club).": "No Serie A data yet. Click \"Upload matchday\" and load one file per matchday (Team column + one row per club).",
  "Carica giornata": "Upload matchday",
  "Aggiungi squadra": "Add team",
  "Seleziona almeno 3 metriche e gli elementi da confrontare (la media Serie A è sempre mostrata come riferimento).": "Select at least 3 metrics and the items to compare (the Serie A average is always shown for reference).",
  "· confronto": "· comparison",
  "Nessuna giornata con dati per": "No matchdays with data for",
  "su queste metriche.": "on these metrics yet.",
};

// Word-level fallback for interpolated/composite strings (e.g. "LORDO LISTA A · 24",
// "azienda 636.835 €"). Only unambiguous football/management domain terms that do NOT
// collide with common English words. Applied after exact-match, with case preservation.
export const IT_EN_WORDS = {
  calciatrici: "players", calciatrice: "player", calciatore: "player", calciatori: "players",
  giornata: "matchday", giornate: "matchdays",
  rosa: "squad",
  prestiti: "loans", prestito: "loan",
  infortunate: "injured", infortunata: "injured", infortunati: "injured",
  infortunio: "injury", infortuni: "injuries",
  azienda: "company",
  lordo: "gross", lorda: "gross", netto: "net", netta: "net",
  scadenza: "expiry", scadenze: "expiries",
  stagione: "season", stagioni: "seasons",
  portieri: "goalkeepers", portiere: "goalkeeper",
  difesa: "defense", centrocampo: "midfield", attacco: "attack",
  mercato: "market",
  ingaggio: "wage", ingaggi: "wages",
  avversario: "opponent", avversaria: "opponent",
  squadra: "team", squadre: "teams",
  giovanile: "youth", professioniste: "professionals",
  lista: "list", liste: "lists", fuori: "out", organico: "squad", settore: "sector",
  anamnesi: "anamnesis", referto: "report", referti: "reports", cartella: "record",
  esame: "exam", esami: "exams", diagnostici: "diagnostic", diagnostico: "diagnostic",
  corporea: "body", interattiva: "interactive", seduta: "session", minutaggio: "minutes",
  disponibile: "available", indisponibile: "unavailable", disponibilità: "availability",
  rientro: "return", gravità: "severity", distorsione: "sprain", recidiva: "recurrence",
  anni: "yrs", anno: "yr", prossima: "next", prossimo: "next",
  mercato: "market", rosa: "squad", infortunata: "injured", infortunate: "injured",
  infortunati: "injured", svincolo: "release", svincolata: "released", rinnovo: "renewal",
  prestito: "loan", prestiti: "loans", nazionali: "internationals", nazionale: "international",
  benessere: "wellness", sonno: "sleep", umore: "mood", fatica: "fatigue", dolore: "pain",
  muscolare: "muscular", carico: "load", allenamento: "training", settimanale: "weekly",
  giornaliero: "daily", soglia: "threshold", soglie: "thresholds", capienza: "capacity",
  capienze: "capacities", stipendio: "salary", stipendi: "salaries", ingaggio: "wage",
  contratto: "contract", contratti: "contracts", buonuscita: "severance",
  promemoria: "reminder", chiusura: "closing", disattivato: "disabled", disattivata: "disabled",
  reparti: "departments", reparto: "department", questionario: "survey",
  costo: "cost", totale: "total", lordo: "gross", raggiunti: "achieved", raggiunto: "achieved",
  raggiunte: "achieved", raggiunta: "achieved", risparmio: "saving", risparmiati: "saved",
  risparmiato: "saved", incentivi: "incentives", incentivo: "incentive", esodo: "severance",
  saldi: "balances", saldo: "balance", storico: "history",
  partita: "match", partite: "matches", metrica: "metric", metriche: "metrics",
  giocate: "played", selezionati: "selected", selezionato: "selected",
  eventi: "events", evento: "event", sessione: "session", sessioni: "sessions",
  allenamenti: "trainings", settimana: "week", settimane: "weeks",
  competizione: "competition", competizioni: "competitions",
  classifica: "standings", classifiche: "standings", confronto: "comparison",
  importate: "imported", importata: "imported", importati: "imported", importato: "imported",
  righe: "rows", riga: "row", vinte: "won", perse: "lost", pareggiate: "drawn", eliminata: "deleted", eliminato: "deleted",
};

// ---------------------------------------------------------------------------
// Export (PDF/JPEG) translation. Pure JS modules read the active language from
// localStorage and translate display labels/headers/titles only (never data).
export function exportLang() {
  try { return localStorage.getItem("pc_lang") === "en" ? "en" : "it"; } catch (e) { return "it"; }
}

// Display-only labels, headers, titles and status values shown in exports.
export const EXPORT_IT_EN = {
  // list composition / counters
  "Lista A (totale)": "List A (total)",
  "Non formate in Italia": "Non-homegrown in Italy",
  "di cui Extra-UE": "of which Non-EU",
  "di cui Britanniche": "of which British",
  "Formate nel club": "Homegrown at club",
  "Internazionali (nazionale)": "Internationals (national team)",
  "Lista B (illimitata)": "List B (unlimited)",
  "Attualmente in prestito (fuori Lista A)": "Currently on loan (outside List A)",
  "Fuori lista (FL + Infortunate)": "Out of list (FL + Injured)",
  "Categoria": "Category",
  "Senza ruolo": "No role",
  // headers
  "Ruolo": "Role", "Scadenza": "Expiry", "Netto": "Net", "Lordo": "Gross",
  "Costo azienda": "Company cost", "Comm. agente": "Agent comm.", "Reparto": "Department",
  "Monte netto": "Net wage bill", "Monte lordo": "Gross wage bill", "Fee agenti": "Agent fees",
  "Costo annuo rosa": "Annual squad cost", "Tipo infortunio": "Injury type", "Data inf.": "Inj. date",
  "Rientro stimato": "Est. return", "Sett. stop": "Weeks out", "Cognome": "Surname", "Nome": "Name",
  "Tipo": "Type", "Rientro": "Return", "Stato": "Status", "Finestra": "Window",
  "Ingaggi in entrata (IN)": "Incoming wages (IN)", "Incentivi esodo (out)": "Exit incentives (out)",
  "Incentivi esodo": "Exit incentives", "Ingaggio/Risparmio": "Wage/Saving", "Fee / Incasso": "Fee / Proceeds",
  // titles
  "Rosa · wages & contracts": "Squad · wages & contracts",
  "Costi totali · Prima Squadra (incl. Fee agenti)": "Total costs · First Team (incl. Agent fees)",
  "Monte ingaggi per reparto": "Wage bill per department",
  "Infortunate · lungo periodo": "Injured · long term",
  "Calciatrici in prestito": "Players on loan",
  "U19 professioniste": "U19 professionals",
  "Staff · Settore giovanile · wages & contracts": "Staff · Youth sector · wages & contracts",
  "Storico saldi · confronto finestre di mercato": "Balance history · transfer windows comparison",
  // market values
  "Cessione": "Sale", "Acquisto": "Signing",
  // status values (shown in Status column + chart bar labels)
  "Non formata in Italia": "Non-homegrown in Italy", "Formata nel club": "Homegrown at club",
  "Formata in Italia": "Homegrown in Italy", "Lista B": "List B", "Infortunata": "Injured",
  "FL (fuori lista)": "FL (out of list)", "Settore giovanile": "Youth sector",
  "Portieri": "Goalkeepers", "Difesa": "Defense", "Centrocampo": "Midfield", "Attacco": "Attack",
  // chart titles
  "Monte ingaggi lordo per status": "Gross wage bill per status",
  "Costo staff lordo per reparto": "Gross staff cost per department",
  "Balance per finestra di mercato": "Balance per transfer window",
  "Proiezione monte ingaggi lordo per stagione (Lista A)": "Gross wage bill projection per season (List A)",
  // author prompt (pdf.js)
  "Ruolo dell'autore:": "Author role:",
  "Autore del dossier (nome e cognome):": "Dossier author (full name):",
  "Esportare come DOSSIER con copertina?\n\nOK = Dossier con copertina\nAnnulla = PDF semplice": "Export as DOSSIER with cover?\n\nOK = Dossier with cover\nCancel = Simple PDF",
};

const EXPORT_PREFIX = { "Riepilogo · ": "Summary · ", "Mercato · ": "Market · " };

export function translateExportString(s) {
  if (typeof s !== "string" || !s) return s;
  const key = s.trim();
  if (!key) return s;
  const hit = EXPORT_IT_EN[key];
  if (hit) {
    const lead = s.slice(0, s.length - s.trimStart().length);
    const trail = s.slice(s.trimEnd().length);
    return lead + hit + trail;
  }
  for (const p in EXPORT_PREFIX) {
    if (s.startsWith(p)) return EXPORT_PREFIX[p] + s.slice(p.length);
  }
  if (/^TOTALE\b/.test(s)) return s.replace(/^TOTALE/, "TOTAL");
  return s;
}

// Deep-translate table sections + charts in place. Only runs for EN.
export function translateExport(sections = [], charts = []) {
  if (exportLang() !== "en") return;
  sections.forEach((sec) => {
    if (sec.title) sec.title = translateExportString(sec.title);
    if (Array.isArray(sec.head)) sec.head = sec.head.map(translateExportString);
    if (Array.isArray(sec.body)) sec.body = sec.body.map((row) => Array.isArray(row) ? row.map(translateExportString) : row);
  });
  charts.forEach((ch) => {
    if (ch.title) ch.title = translateExportString(ch.title);
    if (Array.isArray(ch.bars)) ch.bars.forEach((b) => { if (b && b.label) b.label = translateExportString(b.label); });
  });
}

// Single-string export helper (for prompts etc.).
export function tx(it) {
  if (exportLang() !== "en") return it;
  return EXPORT_IT_EN[it] ?? IT_EN[it] ?? it;
}

// --- Gender-neutral terminology (always applied) ---
// "calciatrice/calciatore" -> "Player", "calciatrici/calciatori" -> "Players" (also in Italian),
// and every other gendered Italian term is normalised to the universal masculine form.
export const FEM_MASC = {
  "le calciatrici": "i Players", "delle calciatrici": "dei Players", "della calciatrice": "del Player", "la calciatrice": "il Player", "una calciatrice": "un Player",
  "le giocatrici": "i Players", "delle giocatrici": "dei Players", "della giocatrice": "del Player", "la giocatrice": "il Player", "una giocatrice": "un Player",
  "i calciatori": "i Players", "dei calciatori": "dei Players", "del calciatore": "del Player", "il calciatore": "il Player", "un calciatore": "un Player",
  "i giocatori": "i Players", "dei giocatori": "dei Players", "del giocatore": "del Player", "il giocatore": "il Player", "un giocatore": "un Player",
  "calciatrici": "Players", "calciatrice": "Player",
  "giocatrici": "Players", "giocatrice": "Player",
  "calciatori": "Players", "calciatore": "Player",
  "giocatori": "Players", "giocatore": "Player",
  "infortunata": "infortunato", "infortunate": "infortunati",
  "professioniste": "professionisti", "professionista": "professionista",
  "formata": "formato", "formate": "formati",
  "convocata": "convocato", "convocate": "convocati",
  "squalificata": "squalificato", "squalificate": "squalificati",
  "svincolata": "svincolato", "svincolate": "svincolati",
  "titolare": "titolare",
};
const FEM_MASC_RE = new RegExp("\\b(" + Object.keys(FEM_MASC).sort((a, b) => b.length - a.length).join("|") + ")\\b", "gi");

export function genderizeText(text) {
  if (!text || !FEM_MASC_RE.test(text)) return text;
  FEM_MASC_RE.lastIndex = 0;
  return text.replace(FEM_MASC_RE, (m) => {
    const rep = FEM_MASC[m.toLowerCase()];
    if (!rep) return m;
    if (m.length > 1 && m === m.toUpperCase()) return rep.toUpperCase();
    if (m[0] === m[0].toUpperCase()) return rep[0].toUpperCase() + rep.slice(1);
    return rep;
  });
}



